import { useEffect, useState } from 'react'
import App from './App'
import { useStateContext } from '@xkit-yx/im-kit-ui'
import general from './general'
import { redux } from './general'
import useActiveState from './lib/useActiveState'

export default function IMAppContainer() {

  const { store,nim } = useStateContext()
  const [allUnreadCount,setAllUnreadCount] = useState(0)
  const [logined,setLogined] = useActiveState('im-logined')

  useEffect(()=>{
    redux.dispatch({
      type:'unread',
      data:{
        unread:allUnreadCount
      }
    })
  },[allUnreadCount])

  const handleUnread = ()=>{
    setAllUnreadCount(store.uiStore.sessionUnread)
  }

  const filterUnreadCount = ()=>{
    setTimeout(() => {
      handleUnread()
    }, 1000);
  }

  useEffect(()=>{
    nim.on('msg',msg=>{
      setTimeout(() => {
        handleUnread()
      }, 100);
    })
    nim.on('syncdone',res=>{
      setLogined(true)
      localStorage.setItem('yx_login',true)
      filterUnreadCount()
    })
    nim.on('logined',()=>{
      localStorage.setItem('yx_login',true)
      setLogined(true)
    })
    nim.on('disconnect',()=>{
      // nim.connect().then(()=>{

      // })
    })
  },[])

  return (
      <App/>
    )
}
